import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreOpticians from './StoreOpticians.js';

const StoreOpticiansContainer = (_param)=>{
    var { opticians , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "opticians",
        "fallbackImage"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.opticians.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(StoreOpticians, swcHelpers.extends({}, rest, {
        opticians: opticians,
        fallbackImage: fallbackImage,
        labels: labels
    }));
};

export { StoreOpticiansContainer as default };
//# sourceMappingURL=StoreOpticiansContainer.js.map
